import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "arranger";
const projects = `${service}/projects`;

export function getProjects() {
  const url = `${projects}`;
  return {
    method: GET,
    url,
  };
}

export function getProjectById(id) {
  const url = `${projects}/${id}`;
  return {
    method: GET,
    url,
  };
}

export function updateProject(id, body) {
  const url = `${projects}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteProject(id) {
  const url = `${projects}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createProject(body) {
  const url = `${projects}`;
  return {
    method: POST,
    url,
    body,
  };
}
